import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzIconService } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  title = 'INÍCIO'
  user = 'Lucas'

  isCollapsed = false;

  selectedItemIndex: number = -1;

  ngOnInit() {
    this.router.navigate(['/consultar-certidao']);
  }

  selectItem(index: number) {
    this.selectedItemIndex = index;
  }

  onMenuClick(event: MouseEvent) {
    event.stopPropagation();
  }
  
  constructor(private elRef: ElementRef, private router: Router) {
    const headers:Headers = new Headers();
            headers.set('Content-Type', 'application/json');
            headers.append('Access-Control-Allow-Origin', '*');
            headers.append('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, PATCH, DELETE');
            headers.append('Access-Control-Allow-Headers', 'X-Requested-With,content-type,Authorization');
  }
  
}
